import WarningAmberIcon from '@mui/icons-material/WarningAmber'

import { FundingNeedResponse } from '@/models/FundingNeeds'
import { AccessibleTooltip } from '../AccessibleTooltip'
import { useFundingNeedStaleness } from '@/utils/hooks/useFundingNeedStaleness'

interface FundingNeedStaleWarningIconProps {
  token: string
  fundingNeed: FundingNeedResponse
  scanIds?: number[]
}

/**
 * Rendered on its own, to the left of the View/Edit and match-action
 * buttons, so it reads as a heads-up about the row rather than being
 * squeezed in between two unrelated buttons.
 */
export default function FundingNeedStaleWarningIcon({
  token,
  fundingNeed,
  scanIds,
}: FundingNeedStaleWarningIconProps) {
  const { warningMessage } = useFundingNeedStaleness(token, fundingNeed, scanIds)

  if (!warningMessage) {
    return null
  }

  return (
    <AccessibleTooltip title={warningMessage} arrow placement="top">
      <span
        role="img"
        aria-label={`Warning: ${warningMessage}`}
        tabIndex={0}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <WarningAmberIcon sx={{ color: 'warning.main', fontSize: '22px' }} />
      </span>
    </AccessibleTooltip>
  )
}
